import {useQuery} from '@tanstack/react-query';
import {PrintGuideParams} from 'domain/usecases';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getPrintGuide} from '../services/getPrintGuide';

export const useGetPrintGuideQuery = (params: PrintGuideParams) =>
	useQuery({
		queryKey: [QUERY_KEYS.AUTOSOL_PRINT_GUIDE, params],
		queryFn: async ({signal}) => getPrintGuide({...params, signal}),
		enabled: false,
	});
